import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { chatGroups } from "@/mocks/homeData";

export default function ChatWall() {
  return (
    <section id="chat" className="w-full bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-24">
        <Reveal>
          <SectionHeading
            index="04"
            eyebrow="Class Chat"
            title="班级群聊截图墙"
            desc="班级群聊是校内传闻流传最快的地方。这里把同学提供的群聊片段做了整理，只保留与事件相关的对话，名字均作模糊处理。"
          />
        </Reveal>

        <div className="mt-10 grid gap-6 md:mt-14 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {chatGroups.map((group, index) => (
            <Reveal key={group.group} delay={index * 90}>
              <div className="flex h-full flex-col rounded-lg border border-background-300/70 bg-background-50 p-5 md:p-6">
                <div className="flex items-start justify-between gap-3 border-b border-foreground-900/10 pb-4">
                  <div>
                    <p className="font-heading text-sm font-bold text-foreground-950">{group.group}</p>
                    <p className="mt-1 text-[11px] text-foreground-500">{group.meta}</p>
                  </div>
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className="ri-chat-3-line" />
                  </span>
                </div>

                <div className="flex flex-1 flex-col gap-3 py-4">
                  {group.messages.map((message, msgIndex) => (
                    <div
                      key={`${group.group}-${msgIndex}`}
                      className={message.own ? "flex flex-col items-end" : "flex flex-col items-start"}
                    >
                      <span className="mb-1 text-[11px] text-foreground-500">{message.name}</span>
                      <p
                        className={[
                          "max-w-[86%] rounded-lg px-3 py-2 text-sm leading-relaxed",
                          message.own
                            ? "rounded-br-sm bg-primary-500 text-background-50"
                            : "rounded-bl-sm bg-background-200 text-foreground-800",
                        ].join(" ")}
                      >
                        {message.text}
                      </p>
                    </div>
                  ))}
                </div>

                <div className="border-t border-foreground-900/10 pt-4">
                  <a
                    href="#chat"
                    className="inline-flex cursor-pointer items-center gap-1 text-xs text-foreground-600 transition-colors hover:text-accent-600"
                  >
                    展开完整群聊
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-s-line" />
                    </span>
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-8" delay={120}>
          <p className="rounded-lg border border-background-300/60 bg-background-50 px-5 py-4 text-xs leading-relaxed text-foreground-500">
            说明：群聊截图已对昵称与头像作模糊处理。截图仅代表局部对话，完整语境请以学校官方说明为准。
          </p>
        </Reveal>
      </div>
    </section>
  );
}